// dbext:profile=staging_mcdo2019_be
import $        from "jquery";
import Sortable from "sortablejs";
import Cleave   from 'cleave.js';

import admin_general      from "./905-admin_general.js";
import admin_crud         from "./910-admin_crud.js";
import admin_upload_image from "./911-admin_upload_image.js";
import admin_multiselect  from "./912-admin_multiselect.js";
import admin_tinymce      from "./914-admin_tinymce.js";

/*

select * from 131_product_category   where product_id not in ( select id from 102_product );
select * from 151_product_ingredient where product_id not in ( select id from 102_product );
select * from 171_related_products   where product_id not in ( select id from 102_product );

select * from 131_product_category where category_id not in ( select id from 130_category );

*/

export default {

    async init()
    {
        // products overview?
        if ( $('.c-admin-products' ).length > 0 ){
            this.init_products();
        }
        // product page?
        else if ( $('.c-admin-product' ).length > 0 ){
            this.init_product();
        }
    },

    //⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  PRODUCTS  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_products()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // set sortable so the products can be sorted in a category
        $('.js-products--sortable').each( ( i, el ) => {
            new Sortable( el, {
                animation : 100,
                onUpdate  : this.on__sort_products_in_category__update(),
            } );
        } );
    },

    on__sort_products_in_category__update()
    {
        return async ( e ) => {

            // dom elements
            let de_sorted_item = $(e.item);
            let de_category    = de_sorted_item.closest('ul')

            // category id - language
            let category_id = de_category.data('category_id');
            let language    = de_category.data('language'   );

            // products ids
            let product_ids = [];
            de_category.find( 'li' ).each(( i, de_product ) => {
                de_product = $(de_product);
                product_ids.push( de_product.data('product_id') );
            });

            // weight field
            let weight_field = 'weight_' + language;

            var weight = 10;
            for ( let product_id of product_ids ){

                let response = await
                admin_crud.POST( admin_crud.posturl( '131_product_category', 'update' ), {
                    ids  : {
                            'product_id' : product_id ,
                            'category_id': category_id,
                           },
                    data:  {
                            [weight_field] : weight,
                           },
                } );

                weight += 10;
            }
        };
    },

    //⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  PRODUCT  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_product()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // event handlers
        $('.js-form'                         ).on( 'submit', this.on__form__submit()         );
        $('.js-delete-button'                ).on( 'click' , this.on__delete_button__click() );
        $('.js-tab__delete'                  ).on( 'click' , this.on__delete_tab__click()    );

        // generate slug buttons
        if ( $('.js-link-generate-slug--product').length > 0 ){
            $('.js-link-generate-slug--product').on( 'click', this.on__slug_arrow__click() );
        }

        // initialize the image upload
        let image_upload = new admin_upload_image();
        image_upload.init( {
            wrapper_class : '.js-image-upload',
            post_url      : '/admin/upload/product-image',
        } );

        // slugification
        $('[name="name_en"]').on( 'blur', this.on__name__blur() );
        $('[name="name_nl"]').on( 'blur', this.on__name__blur() );
        $('[name="name_fr"]').on( 'blur', this.on__name__blur() );

        // reset all checkboxes (they get checked later)
        $('.js-category__checkbox'                  ).prop( 'checked', false );
        $('.js-allergen-contains__checkbox'         ).prop( 'checked', false );
        $('.js-allergen-contact__checkbox'          ).prop( 'checked', false );
        $('.js-allergens-details__checkbox'         ).prop( 'checked', false );
        $('.js-mcmoment-scheduling__checkbox'       ).prop( 'checked', false );
        $('.js-mcmoment-scheduling-month__checkbox' ).prop( 'checked', false );

        // mcmoment scheduling
        $('.js-mcmoment-scheduling__checkbox').on( 'change', this.on__mcmoment_scheduling_checkbox__change() );

        // alergens checkbox clicking
        $('.js-allergen-contains__checkbox, .js-allergen-contact__checkbox').on( 'change', this.on__allergen_checkbox__change() );
        $('.js-allgergens-details__checkbox'                               ).on( 'change', this.on__allergen_details_checkbox__change() );

        // variant order with sortable
        if ( $('.js-variants--sortable').length > 0 ){
            new Sortable( $('.js-variants--sortable')[0], {
                animation : 100,
                onUpdate  : this.on__sort_variants__update(),
            } );
        }

        // variant order: insert a new product? ⇒ set default value
        if ( g_mode === 'insert' ){
            $('input[name="variant_order"]').val('1');
        }

        // insert mode?
        if ( g_mode === 'insert' ){

            // set mcmoment scheduling default off
            $('.c-mcmoment-scheduling__months').addClass('is-disabled');

            // published default on
            $('input[name="published"]').prop( 'checked', true );
        }

        // update mode? ⇒ make frontend reflect g_product
        if ( g_mode === 'update' ){

            for ( let [ key, value ] of Object.entries( g_product ) ){

                if ( key === 'image' && value ){
                    image_upload.set_image( value );
                    continue;
                }

                if ( key === 'categories' && value && typeof value === 'object' && value.length > 0 ){
                    for ( let category of value ){
                        $('.js-category__checkbox[value="'+category.id+'"]').prop( 'checked', true );
                    }
                    continue;
                }

                // no McMoment scheduling? ⇒ disable the months
                if ( key === 'mcmoment_scheduling' && value == 0 ){
                    $('.c-mcmoment-scheduling__months').addClass('is-disabled');
                    continue;
                }

                if ( key === 'allergens_contains' && value ){
                    let allergens_contains = JSON.parse( value );
                    for ( let allergen of allergens_contains ){
                        $('input[name="allergen_contains"][value="'+allergen+'"]').prop( 'checked', true );
                    }
                    continue;
                }

                if ( key === 'allergens_contact' && value ){
                    let allergens_contact = JSON.parse( value );
                    for ( let allergen of allergens_contact ){
                        $('input[name="allergen_contact"][value="'+allergen+'"]').prop( 'checked', true );
                    }
                    continue;
                }

                if ( key === 'allergens_details' && value ){
                    let allergens_details = null;
                    try {
                        allergens_details = JSON.parse( value );
                    }
                    catch {
                        continue;
                    }
                    for ( let [ key2, value2 ] of Object.entries( allergens_details ) ){
                        for ( let allergen_detail of value2 ){
                            $('input[name="allergens_details"][value="'+key2+'|'+allergen_detail+'"]').prop( 'checked', true );
                        }
                    }
                    continue;
                }

                // handle ingredients later on
                if ( key == 'ingredients' ){
                    continue;
                }

                // get the DOM element
                let de = $('[name="' + key + '"]');
                if ( de.length === 0 ){
                    continue;
                }

                // input type text
                if ( de.attr('type') === 'text' ){
                    de.val( value );
                    continue;
                }

                // input type number
                if ( de.attr('type') === 'number' ){
                    de.val( value );
                    continue;
                }

                // input type checkbox
                if ( de.attr('type') === 'checkbox' ){
                    de.prop( 'checked', ( value == 1 ) );
                    continue;
                }

                // textarea
                if ( de.is( 'textarea' ) ){
                    de.val( value );
                    continue;
                }

                // select
                if ( de.is( 'select' ) ){
                    de.val( value );
                    continue;
                }

            }
        }

        { // set input masks on the nutritional information
            for ( let de of $('input.js-cleave-2dec') ){
                new Cleave( de, {
                    numeral                    : true,
                    numeralDecimalScale        : 2,
                    numeralPositiveOnly        : true,
                    stripLeadingZeroes         : false,
                    numeralThousandsGroupStyle : 'none',
                } );
            }
            for ( let de of $('input.js-cleave-int') ){
                new Cleave( de, {
                    numeral                    : true,
                    numeralDecimalScale        : 0,
                    numeralPositiveOnly        : true,
                    stripLeadingZeroes         : false,
                    numeralThousandsGroupStyle : 'none',
                } );
            }
        }

        { // ingredients

            // db select all ingredients
            let ingredients = await admin_crud.GET(  admin_crud.posturl( '150_ingredient', 'select_all' ), {} );
            ingredients = ingredients.data;

            // make lookup of selected ingredients in g_product
            let lookup = {};
            if ( g_product && g_product.ingredients ){
                for ( let selected_ingredient of g_product.ingredients ){
                    lookup[ selected_ingredient.id ] = selected_ingredient;
                }
            }

            let selected  = [];
            let available = [];

            for ( let ingredient of ingredients ){

                // selected ingredient?
                if ( lookup[ ingredient.id ] ){
                    selected.push({
                        'value'    : ingredient.id                  ,
                        'name'     : ingredient.name_nl             ,
                        'selected' : true                           ,
                        'weight'   : parseInt( lookup[ ingredient.id ].weight ),
                    });
                }
                else { // not selected
                    available.push({
                        'value'    : ingredient.id      ,
                        'name'     : ingredient.name_nl ,
                        'selected' : false              ,
                    });
                }
            }

            // sort selected on weight descending
            selected.sort( ( a, b ) => {
                return a.weight - b.weight;
            } );
            available.sort( ( a, b ) => {
                return a.name.localeCompare( b.name );
            } );

            // rejoin
            ingredients = [ ...selected, ...available ];

            // initialize the ingredients multiselect
            this.ingredients_multiselect = new admin_multiselect();
            this.ingredients_multiselect.init({
                select_name   : 'ingredients',
                wrapper_class : '.js-ingredients-multiselect',
                data          : ingredients,
            });
        }

        admin_tinymce.init();
    },

    on__form__submit()
    {
        return async ( e ) => {

            e.preventDefault();

            admin_general.start_spinning();

            // delete button clicked? ⇒ handle separately
            if ( $('.js-delete-button').data( 'delete-button-clicked' ) ){
                $('.js-delete-button').removeData( 'delete-button-clicked' );
                return this.on__form_delete__submit();
            }

            { // collect form data

                var category_ids = [];
                var product_data = {
                    'allergens_contains': [],
                    'allergens_contact' : [],
                    'allergens_details' : {},
                };
                var ingredient_ids = [];

                // get form data
                let form_data = $('.js-form').serializeArray();

                // form data → data structures
                for ( let { name, value } of form_data ){

                    if ( name == 'category_id' ){
                        category_ids.push( value );
                        continue;
                    }

                    if ( name == 'allergen_contains' ){
                        product_data['allergens_contains'].push( value );
                        continue;
                    }

                    if ( name == 'allergen_contact' ){
                        product_data['allergens_contact'].push( value );
                        continue;
                    }

                    if ( name == 'allergens_details' ){
                        let [ ad_category, ad_detail ] = value.split( '|', 2 );
                        if ( ! ad_category || ! ad_detail ){
                            continue;
                        }
                        if ( ! product_data['allergens_details'][ ad_category ] ){
                            product_data['allergens_details'][ ad_category ] = [];
                        }
                        product_data['allergens_details'][ ad_category ].push( ad_detail );
                        continue;
                    }

                    // ingredients
                    if ( name == 'ingredients' ){
//                      ingredient_ids = this.ingredients_multiselect.selected();
                        ingredient_ids.push( value );
                        continue;
                    }

                    // TinyMCE? ⇒ retreive value with tinymce.get()
                    if (   name == 'body_en'
                        || name == 'body_nl'
                        || name == 'body_fr'
                       ){
                           var id_body = 'i-' + name ;
                           product_data[ name ] = admin_tinymce.get_content( id_body );
                           continue;
                   }

                    product_data[ name ] = value;
                }

                { // mcmoment scheduling, not set? ⇒ 0
                    let mcms_keys = [
                        'mcmoment_scheduling'    ,
                        'mcmoment_scheduling_jan',
                        'mcmoment_scheduling_feb',
                        'mcmoment_scheduling_mar',
                        'mcmoment_scheduling_apr',
                        'mcmoment_scheduling_may',
                        'mcmoment_scheduling_jun',
                        'mcmoment_scheduling_jul',
                        'mcmoment_scheduling_aug',
                        'mcmoment_scheduling_sep',
                        'mcmoment_scheduling_oct',
                        'mcmoment_scheduling_nov',
                        'mcmoment_scheduling_dec',
                    ];

                    for ( let key of mcms_keys ){
                        if ( ! product_data[key] ){
                            product_data[key] = 0;
                        }
                    }
                }

                { // allergens
                    if ( product_data['allergens_contains'].length !== 0 ){
                        product_data['allergens_contains']
                            = JSON.stringify( product_data['allergens_contains'] );
                    }
                    else {
                        product_data['allergens_contains'] = '';
                    }
                    if ( product_data['allergens_contact'].length !== 0 ){
                        product_data['allergens_contact']
                            = JSON.stringify( product_data['allergens_contact'] );
                    }
                    else {
                        product_data['allergens_contact'] = '';
                    }
                    if ( Object.keys( product_data['allergens_details'] ).length > 0 ){
                        product_data['allergens_details']
                            = JSON.stringify( product_data['allergens_details'] );
                    }
                    else {
                        product_data['allergens_details'] = '';
                    }
                }

                // empty checkboxes ⇒ serialize explicitely
                if ( ! product_data['published'] ){
                    product_data['published'] = 0;
                }

                // empty select ⇒ serialize explicitely
                if ( ! product_data['related_products_grouping_id'] ){
                    product_data['related_products_grouping_id'] = null;
                }

            }

            // validate_input
            let validated = this.validate_input( category_ids, product_data );
            if ( ! validated ){

                // show errors
                $('.c-saved.c-saved--errors').show();
                $('.c-saved.c-saved--errors').fadeOut( 2000 );

                admin_general.stop_spinning();

                return;
            }

            // this will contain product-id later
            let product_id = false;

            // insert? ⇒ insert product data in database and get the product_id
            if ( g_mode === 'insert' ){

                // insert product datacfr. 910-admin-crud.js
                let response = await
                admin_crud.POST( admin_crud.posturl( '102_product', 'insert' ), {
                    data : product_data,
                } );

                product_id = response.data.id;
            }

            // update? ⇒ update product data in database
            if ( g_mode === 'update' ){

                // get product-id from g_product
                product_id = g_product.id

                let ids = {
                    'id': product_id
                };

                let response = await
                admin_crud.POST( admin_crud.posturl( '102_product', 'update' ), {
                    ids  : {
                            'id': product_id,
                           },
                    data : product_data,
                } );
            }

            // insert? ⇒ insert all product categories with low weights
            if ( g_mode === 'insert' ){

                // insert? ⇒ insert product categories
                for ( let category_id of category_ids ){

                    let response = await
                    admin_crud.POST( admin_crud.posturl( '131_product_category', 'insert' ), {
                        data : {
                            product_id  : product_id,
                            category_id : category_id,
                            visible     : 1,
                            weight_en   : 5,
                            weight_nl   : 5,
                            weight_fr   : 5,
                        }
                    } );
                }
            }

            // update? ⇒ clear all existing product categories and reinsert
            if ( g_mode === 'update' ){

                // load weights of existing product categories
                let old_category_weights = {};
                let response = await admin_crud.GET(  admin_crud.posturl( '131_product_category', 'select_all' ), {} );
                let product_categories = response.data;
                product_categories = product_categories.filter( ( pc ) => {
                    return pc.product_id == product_id;
                } );

                for ( let pc of product_categories ){
                    if ( ! old_category_weights[ pc.category_id ] ){
                        old_category_weights[ pc.category_id ] = {};
                    }
                    old_category_weights[ pc.category_id ].weight_en = pc.weight_en;
                    old_category_weights[ pc.category_id ].weight_nl = pc.weight_nl;
                    old_category_weights[ pc.category_id ].weight_fr = pc.weight_fr;
                }

                // delete existing product categories
                await this.delete_product_categories();

                for ( let category_id of category_ids ){

                    // insert product categories default with a low weight
                    let weight_en = 5;
                    let weight_nl = 5;
                    let weight_fr = 5;

                    // keep old category weights when possible
                    if ( old_category_weights[ category_id ] ){
                        weight_en = old_category_weights[ category_id ].weight_en ;
                        weight_nl = old_category_weights[ category_id ].weight_nl ;
                        weight_fr = old_category_weights[ category_id ].weight_fr ;
                    }

                    let response = await
                    admin_crud.POST( admin_crud.posturl( '131_product_category', 'insert' ), {
                        data : {
                            product_id  : product_id  ,
                            category_id : category_id ,
                            visible     : 1           ,
                            weight_en   : weight_en   ,
                            weight_nl   : weight_nl   ,
                            weight_fr   : weight_fr   ,
                        }
                    } );
                }
            }

            // update? ⇒ clear all existing ingredients
            if ( g_mode === 'update' ){
                await this.delete_product_ingredients();
            }

            // update/insert ⇒ insert product ingredients
            let weight = 10;
            for ( let ingredient_id of ingredient_ids ){

                let response = await
                admin_crud.POST( admin_crud.posturl( '151_product_ingredient', 'insert' ), {
                    data : {
                        product_id    : product_id    ,
                        ingredient_id : ingredient_id ,
                        weight        : weight        ,
                    }
                } );

                weight += 10;
            }

            { // handle redirect/reload

                if ( g_mode === 'insert' ){

                    let target_url = '/admin/product/' + product_id;

                    // redirect to the edit page of the new product
                    window.location.replace( target_url );
                }
                else if ( g_mode === 'update' ){

                    // show product saved
                    $('.c-saved.c-saved--ok').show();
                    $('.c-saved.c-saved--ok').fadeOut('slow');
                }
            }

            // it is possible that the slug has changed ⇒ make the link in the "View" tab reflect that change
            if ( g_mode === 'update' ){
                // regenerate view link
                this.regenerate_view_tab_link_after_save();
            }

            admin_general.stop_spinning();

        };
    },

    on__delete_button__click()
    {
        return ( e ) => {
            $('.js-delete-button').data( 'delete-button-clicked', true );
        };
    },

    on__delete_tab__click()
    {
        return ( e ) => {
            e.preventDefault();

            // fake that somebody clicked on the delete button on the bottom of the page
            $('.js-delete-button').click();
        };
    },

    async on__form_delete__submit()
    {
        // are your sure?
        if ( ! confirm( 'Are you sure?' ) ){
            admin_general.stop_spinning();
            return; // user is not sure...
        }

        // delete product categories
        await this.delete_product_categories();

        // delete product ingredients
        await this.delete_product_ingredients();

        // delete related producst groupings
        await this.delete_related_products_groupings();

        // delete product record
        let response = await
        admin_crud.POST( admin_crud.posturl( '102_product', 'delete' ), {
            ids : {
                id : g_product.id,
            },
        } );

        // redirect to products overview
        window.location.replace( '/admin/products' );

        return;
    },

    validate_input( category_ids, product_data )
    {
        $('.is-error').removeClass( 'is-error' );

        let validated = true;
        if ( category_ids.length === 0 ){
            validated = false;
            $('.js-categories').addClass( 'is-error' );
        }

        for ( let key of [ 'name_en', 'name_nl', 'name_fr',  ] ){
            if ( ! product_data[key] ){
                validated = false;
                $('[name="'+key+'"]').addClass( 'is-error' );
            }
        }

        for ( let key of [ 'slug_en', 'slug_nl', 'slug_fr', ] ){
            if ( ! product_data[key] ){
                validated = false;
                $('[name="'+key+'"]').addClass( 'is-error' );
                continue;
            }

            if ( ! product_data[key].match( /^[a-z0-9-]+$/ ) ){
                validated = false;
                $('[name="'+key+'"]').addClass( 'is-error' );
                continue;
            }
        }

        return validated;
    },

    async delete_product_categories()
    {
        if ( ! g_product.id ){
            return;
        }

        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '131_product_category', 'select_where' ), {
                'where' : {
                    'product_id': g_product.id,
                }
            } );
            return response.data;
        })();

        // delete records
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '131_product_category', 'delete' ), {
                ids : {
                    product_id  : g_product.id,
                    category_id : r.category_id,
                },
            } );
        }
    },

    async delete_product_ingredients()
    {
        if ( ! g_product.id ){
            return;
        }

        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '151_product_ingredient', 'select_where' ), {
                'where' : {
                    'product_id': g_product.id,
                }
            } );
            return response.data;
        })();

        // delete records
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '151_product_ingredient', 'delete' ), {
                ids : {
                    product_id    : g_product.id    ,
                    ingredient_id : r.ingredient_id ,
                },
            } );
        }
    },

    async delete_related_products_groupings()
    {
        if ( ! g_product.id ){
            return;
        }

        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '171_related_products', 'select_where' ), {
                'where' : {
                    'product_id': g_product.id,
                }
            } );
            return response.data;
        })();

        // delete records
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '171_related_products', 'delete' ), {
                ids : {
                    product_id  : g_product.id  ,
                    grouping_id : r.grouping_id ,
                },
            } );
        }
    },

    on__name__blur()
    {
        return ( e ) => {
            let de_name  = $(e.currentTarget);
            let name     = de_name.attr( 'name' );
            let language = name.replace( /^.*_/, '' );

            this.set_slug( language, false /* don't overwrite */ );
        };
    },

    on__slug_arrow__click()
    {
        return ( e ) => {
            e.preventDefault();

            let de_clicked = $(e.currentTarget);
            let language   = de_clicked.data('language');

            this.set_slug( language, true /* overwrite */  );
        };
    },

    set_slug( language, overwrite )
    {
        // source and target dom elements
        let de_source_name    = $('input[name="name_'    + language + '"]');
        let de_source_variant = $('input[name="variant_' + language + '"]');
        let de_target_slug    = $('input[name="slug_'    + language + '"]');

        // get name + variant values
        let source_name    = de_source_name   .val();
        let source_variant = de_source_variant.val();
        let target_slug    = de_target_slug   .val();

        // source name empty? ⇒ do nothing
        if ( ! source_name ){
            return;
        }

        // target slug already set and should not overwrite? ⇒ do nothing
        if ( target_slug && ! overwrite ){
            return;
        }

        // slugify the product name
        target_slug = admin_general.slugify( source_name );

        // variant set? ⇒ add it
        if ( source_variant ){
            target_slug += '-' + admin_general.slugify( source_variant );
        }

        de_target_slug.val( target_slug );

        admin_general.flash_background( de_target_slug );
    },

    on__sort_variants__update()
    {
        return async ( e ) => {

            // dom elements
            let de_sorted_item = $(e.item);

            // variant ids
            let variant_ids = [];

            // collect de_variants
            let de_variants = $('.js-variants--sortable').find('li');

            // iterate variants
            let variant_order = 1;
            for ( let de_variant of de_variants ){
                de_variant = $(de_variant);

                // get variant_id (= product_id )
                let variant_id = de_variant.data( 'variant_id' );

                // update product variant
                let response = await
                admin_crud.POST( admin_crud.posturl( '102_product', 'update' ), {
                    ids  : {
                            'id' : variant_id ,
                           },
                    data:  {
                            'variant_order' : variant_order,
                           },
                } );

                // set new number in variant list
                let de_variant_order = de_variant.find( '.js-variant__order' );
                de_variant_order.text( variant_order );

                variant_order += 1;
            }
        };
    },

    on__allergen_checkbox__change()
    {
        return ( e ) => {

            let de_cb = $(e.target);

            // unchecking the checkbox? ⇒ clear all allergen details
            if ( ! de_cb.is(':checked') ){
                de_cb.next('label').next('ul').find( 'input[type="checkbox"]' ).prop( 'checked', false );
                de_cb.next('label').next('ul').find( 'input[type="checkbox"]' ).css( 'border', '5px solid red' );
            }
        };
    },

    on__allergen_details_checkbox__change()
    {
        return ( e ) => {

            let de_cb = $(e.target);

            // checking a details checkbox? ⇒ make sure the main checkbox is checked
            if ( de_cb.is(':checked') ){
                de_cb.closest('ul').prev('label').prev('input[type="checkbox"]').prop( 'checked', true );
            }
        };
    },

    regenerate_view_tab_link_after_save()
    {
        // compose the link
        let lg = g_language;
        let link = '';
        switch (lg) {
            case 'en': link = '/en/our-menu/'   + $(`input[name="slug_${lg}"]`).val() ; break;
            case 'nl': link = '/nl/ons-menu/'   + $(`input[name="slug_${lg}"]`).val() ; break;
            case 'fr': link = '/fr/notre-menu/' + $(`input[name="slug_${lg}"]`).val() ; break;
        }

        // set the link in the "View" tab
        $('.js-tab__view a').attr( 'href', link );
    },

    on__mcmoment_scheduling_checkbox__change()
    {
        return ( e ) => {

            let de_cb = $(e.target);

            // checking
            if ( de_cb.is(':checked') ){
                $('.c-mcmoment-scheduling__months').removeClass('is-disabled');
                $('.c-mcmoment-scheduling__months').addClass('is-enabled');
            }
            else { // unchecking
                $('.c-mcmoment-scheduling__months').removeClass('is-enabled');
                $('.c-mcmoment-scheduling__months').addClass('is-disabled');

                // uncheck all month checkboxes
                $('.js-mcmoment-scheduling-month__checkbox' ).prop( 'checked', false );
            }
        };
    },

}

